module.exports = "sanction"